<h2 class="m-b-5" mat-dialog-title>Editar Autor</h2>

<!-- <app-modern-author [leave-id]="data.leaveId" [authorFormGroup]="data.authorFormGroup"></app-modern-author> -->

<app-globle-author *ngIf="isShowAutor" [editAuthorFormGroup]="data.authorFormGroup" [authorFormGroup]="taskManagementService.TaskManagementForm.get('Author')" [moduleName]="responsibleModuleName" [authorTypes]="responsibleAuthorTypes" [authComponentModel]="authComponentModel">
</app-globle-author>

<div class="text-a-r p-t-5">
    <button mat-raised-button color="accent" class="m-r-15" (click)="confirmUpdate()">Guardar</button>
    <button mat-raised-button color="warn" (click)="declineUpdate()">Cancelar</button>
</div>